import { Button } from '@slot-nx/core'
import btn_godzidrop_pressed from '../../../asset/images/godzidrop/btn_godzidrop_pressed.png'
import btn_godzidrop_disable from '../../../asset/images/godzidrop/btn_godzidrop_disable.png'
import btn_godzidrop_hover from '../../../asset/images/godzidrop/btn_godzidrop_hover.png'
import btn_godzidrop_normal from '../../../asset/images/godzidrop/btn_godzidrop_normal.png'
import { Assets } from 'pixi.js'
import { useGodziDropStore } from '../../domain/godziDrop/store/godziDropStore'
import { useEffect } from 'react'
import { godziDashboardService } from '../../domain/godziDrop/service/GodziDashboardService'

Assets.addBundle('Godzidrop', {
  btn_godzidrop_pressed: { src: btn_godzidrop_pressed, loadParser: 'loadTextures' },
  btn_godzidrop_disable: { src: btn_godzidrop_disable, loadParser: 'loadTextures' },
  btn_godzidrop_hover: { src: btn_godzidrop_hover, loadParser: 'loadTextures' },
  btn_godzidrop_normal: { src: btn_godzidrop_normal, loadParser: 'loadTextures' },
})

export const GodziDropIcon = () => {
  const godziDropStore = useGodziDropStore()

  useEffect(() => {
    if (godziDropStore.isShowDashboard) {
      godziDashboardService.updateIFrameSize()
      godziDashboardService.openGodziDropDashBoard()
    }
  }, [godziDropStore.isShowDashboard])

  return (
    godziDropStore.eventInfo.isIconOpen
      ? (
          <Button
            name="godziIcon"
            x={5}
            y={70}
            enabled={true}
            visible={true}
            width={130}
            height={116}
            defaultView="btn_godzidrop_normal"
            hoverView="btn_godzidrop_hover"
            disabledView="btn_godzidrop_disable"
            pressedView="btn_godzidrop_pressed"
            onPress={() => {
              useGodziDropStore.setState({
                isShowDashboard: true,
              })
            }}
          />
        )
      : null
  )
}
